import DeliveryService from "../DeliveryService";

const Wallet = {
  formData(data) {
    let form = new FormData();
    for (let obj in data) {
      form.append(obj, data[obj]);
    }
    return form;
  },
  gets(params) {
    return DeliveryService.get(`/console/wallet/deposits`);
  },
  update(data) {
    return DeliveryService.post(
      `/console/wallet/deposits/` + data.reference,
      data
    );
  },
};

export default Wallet;
